<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>

<div *ngIf="!load">
  <div class="container-fluid" style="padding-bottom: 10%;">
    <div class=" d-flex" style="margin-top: 7%;padding-left: 13px;">
      <div class="">
        <img src="../../../../assets/img/backMenu.svg" alt="" (click)="backToFoodMenu()" style="cursor: pointer;">
      </div>
      <div class="restoName ">
        My Food Preferences
      </div>
    </div>

    <div>
      <div class="d-flex pl-13 ">
        Select spice tolerance
      </div>
      <div class="container-fluid marg-t8 custom-slider">
        <ng5-slider [(value)]="spiceTollerence" [options]="options"></ng5-slider>
      </div>
    </div>

    <div>
      <div class="d-flex pl-13 ">
        My food allergies/Intolerance
      </div>
      <div class="container marg-t8">
        <ng-select [(ngModel)]="allergensarry" name="allergensarry" [items]="allAllergens" bindLabel="allergens_name" [multiple]="true" [virtualScroll]="true" placeholder="My food allergies/Intolerance" bindValue="allergens_id"  required>
        </ng-select>
      </div>
    </div>

    <div>
      <div class="d-flex pl-13 ">
        My dietary preferences
      </div>
      <div class="container marg-t8">
        <ng-select [multiple]="true" [virtualScroll]="true" placeholder="My dietary preferences" required>
        </ng-select>
      </div>
    </div>

    <div>
      <div class="d-flex pl-13 ">
        My favourite ingredients
      </div>
      <div class="container marg-t8">
        <ng-select [multiple]="true" [virtualScroll]="true" placeholder="My favourite ingredients" required>
        </ng-select>
      </div>
    </div>

    <div>
      <div class="d-flex pl-13 ">
        Dislikes
      </div>
      <div class="container marg-t8">
        <ng-select name="userDislikesbind" [multiple]="true" [virtualScroll]="true" placeholder="Dislikes" required>
        </ng-select>
      </div>
    </div>

    <div class="container">
      <button class="btn-update" type="submit" (click)="updateUserPreferences()">Update</button>
    </div>
  </div>
</div>

<div *ngIf="load">
  
  <form autocomplete="off">
    <div class="container-fluid" style="padding-bottom: 10%;">
      <div class=" d-flex" style="margin-top: 7%;padding-left: 13px;">
        <div class="">
          <img src="../../../../assets/img/backMenu.svg" alt="" (click)="backToFoodMenu()" style="cursor: pointer;">
        </div>
        <div class="restoName ">
          My Food Preferences
        </div>
      </div>

      <div>
        <div class="d-flex pl-13 ">
          Select spice tolerance
        </div>
        <div class="container-fluid marg-t8 custom-slider">
          <ng5-slider [(value)]="spiceTollerence" [options]="options"></ng5-slider>
        </div>
      </div>

      <div>
        <div class="d-flex pl-13 ">
          My food allergies/Intolerance
        </div>
        <div class="container marg-t8">
          <ng-select [(ngModel)]="allergensarry" name="allergensarry" [items]="allAllergens" bindLabel="allergens_name"
            bindValue="allergens_id" [multiple]="true" [virtualScroll]="true"
            placeholder="My food allergies/Intolerance" required>
          </ng-select>
        </div>
      </div>

      <div>
        <div class="d-flex pl-13 ">
          My dietary preferences
        </div>
        <div class="container marg-t8">
          <ng-select [(ngModel)]="dietaryarry" name="dietaryarry" [items]="alldietary" bindLabel="diet_preference_name"
            bindValue="diet_preference_id" [multiple]="true" [virtualScroll]="true" placeholder="My dietary preferences"
            required>
          </ng-select>
        </div>
      </div>

      <div>
        <div class="d-flex pl-13 ">
          My favourite ingredients
        </div>
        <div class="container marg-t8">
          <ng-select [(ngModel)]="ingredientbind" name="ingredientbind" [items]="user_ingredients"
            bindLabel="sub_ingredient_name" bindValue="sub_ingredient_id" [multiple]="true" [virtualScroll]="true"
            placeholder="My favourite ingredients" required>
          </ng-select>
        </div>
      </div>

      <div>
        <div class="d-flex pl-13 ">
          Dislikes
        </div>
        <div class="container marg-t8">
          <ng-select [(ngModel)]="userDislikesbind" name="userDislikesbind" [items]="user_ingredients"
            bindLabel="sub_ingredient_name" bindValue="sub_ingredient_id" [multiple]="true" [virtualScroll]="true"
            placeholder="Dislikes" required>
          </ng-select>
        </div>
      </div>

      <div class="container">
        <button class="btn-update" type="submit" (click)="updateUserPreferences()">Update</button>
      </div>
    </div>
  </form>
</div>